import type { AppRequestRoute } from './types'

const routes: Record<AppRequestRoute, string> = {
  'admin.customer.show': '/admin/customers/[customer_id]',
  'admin.customer.subscriptions': '/admin/customers/[customer_id]/subscriptions',
  'admin.customer.orders': '/admin/customers/[customer_id]/orders',
  'admin.customer.changelog': '/admin/customers/[customer_id]/changelog',
  'admin.customer.details': '/admin/customers/[customer_id]/details',
  'admin.customer.statuses-and-sources': '/admin/customers/[customer_id]/statuses-and-sources',
  'admin.customer.comments': '/admin/customers/[customer_id]/comments',
  'admin.customer.credits': '/admin/customers/[customer_id]/credits',
  'admin.kid.show': '/admin/kids/[kid_id]',
  'admin.kid.details': '/admin-api/kids/[kid_id]/details',
  'admin.kid.update': '/admin-api/kids/[kid_id]',
  'admin.kid.destroy': '/admin-api/kids/[kid_id]',
  'admin.kid.changelog': '/admin-api/kids/[kid_id]/changelog',
  'admin.kid.disciplines.store': '/admin-api/disciplines',
  'admin.kid.customer.details': '/admin-api/customers/[customer_id]/details',
  'admin.auth.login': '/admin-api/auth/login',
  'admin.auth.logout': '/admin-api/auth/logout',
  'admin.auth.refresh': '/admin-api/auth/refresh',
  'admin.config.lists': '/admin-api/config/lists',
  'admin.dashboard.data': '/admin-api/dashboard',
  'admin.profile.edit': '/admin/profile',
  'admin.profile.show': '/admin-api/profile',
  'admin.profile.view-timezone': '/admin-api/profile/view-timezone',
  'admin.profile.availability': '/admin-api/profile/availability',
  'admin.privileges': '/admin-api/privileges',
  'admin.tutor-kanban.onboarding': '/admin-api/tutor-kanban/onboarding',
  'admin.tutor-kanban.active': '/admin-api/tutor-kanban/active',
  'admin.tutor-kanban.probation': '/admin-api/tutor-kanban/probation',
  'admin.tutor-kanban.update': '/admin-api/tutor-kanban/[tutor_id]',
  'admin.tutor-kanban.show': '/admin-api/tutor-kanban/[tutor_id]',
  'admin.tutor-kanban.comments': '/admin-api/tutor-kanban/[tutor_id]/comments',
  'admin.tutor-kanban.comments.update': '/admin-api/tutor-kanban/[tutor_id]/comments/[comment_id]',
  'admin.tutor-kanban.comments.delete': '/admin-api/tutor-kanban/[tutor_id]/comments/[comment_id]',
  'admin.tutor-kanban.logs': '/admin-api/tutor-kanban/[tutor_id]/logs',
  'admin.tutors.payment-policies': '/admin-api/tutors/[tutor_id]/payment-policies',
  'admin.tutors.billing': '/admin-api/tutors/[tutor_id]/billing',
  'admin.tutors.billing.list': '/admin-api/tutors/billing',
  'admin.tutors.billing.erase': '/admin-api/tutors/billing/[billing_id]',
  'admin.tutors.billing.bulk-flags': '/admin-api/tutors/billing/bulk-flags',
  'admin.tutors.billing.bulk-confirm': '/admin-api/tutors/billing/bulk-confirm',
  'admin.tutors.billing.bulk-erase': '/admin-api/tutors/billing/bulk-erase',
  'admin.tutors.billing.export': '/admin-api/tutors/billing/export',
  'admin.tutors.billing.change-requests.accept': '/admin-api/tutors/billing/change-requests/[change_request_id]/accept',
  'admin.tutors.billing.change-requests.reject': '/admin-api/tutors/billing/change-requests/[change_request_id]/reject',
  'admin.tutors.billing.change-requests.confirm-salesforce': '/admin-api/tutors/billing/change-requests/[change_request_id]/confirm-salesforce',
  'admin.tutors.sync-policies': '/admin-api/tutors/sync-policies',
  'admin.tutor-kanban.time-offs': '/admin-api/tutor-kanban/[tutor_id]/time-offs',
  'admin.demo-slots.extra-rates': '/admin-api/demo-slots/extra-rates',
  'admin.password': '/admin/forgot-password',
  'admin.user.show': '/admin/users/[user_id]',
  'admin.tutor.show': '/admin/tutors/[tutor_id]',
  'admin.tutors.additional-info': '/admin/tutors/[tutor_id]/additional-info',
  'admin.tutors.schedule.show': '/admin/tutors/[tutor_id]/schedule',
  'admin.tutors.links.show': '/admin/tutors/[tutor_id]/links',
  'admin.changelog.tutor': '/admin/tutors/[tutor_id]/changelog',
  'admin.tutors': '/admin/tutors',
  'admin.customers': '/admin/customers',
  'admin.demo-slots.tracker': '/admin-api/demo-slots/tracker',
  'admin.demo-slots.metrics': '/admin-api/demo-slots/tracker/metrics',
  'admin.demo-slots.waiting-bookings': '/admin-api/demo-slots/tracker/waiting-bookings/list',
  'admin.demo-slots.assign-booking': '/admin-api/demo-slots/[tutor_slot]/assign-booking',
  'admin.tutor-slots.logs': '/admin-api/tutor-slots/logs',
  'admin.tutors.list': '/admin-api/tutors/list',
  'admin.agents': '/admin-api/agents',
  'admin.options': '/admin-api/options',
  'admin.payment-policies.list': '/admin-api/payment-policies/list',
  'admin.kanban-tasks': '/admin-api/kanban-tasks',
  'admin.kanban-tasks.create': '/admin-api/kanban-tasks/create',
  'admin.kanban-tasks.show': '/admin-api/kanban-tasks/[id]',
  'admin.kanban-tasks.update': '/admin-api/kanban-tasks/[id]',
  'admin.kanban-tasks.comments': '/admin-api/kanban-tasks/[task_id]/comments',
  'admin.kanban-tasks.comments.update': '/admin-api/kanban-tasks/[task_id]/comments/[comment_id]',
  'admin.kanban-tasks.logs': '/admin-api/kanban-tasks/[id]/logs',
  'admin.kanban-tasks-comments': '/admin-api/kanban-tasks-comments',
  'admin.disciplines.index': '/admin/disciplines',
  'admin.disciplines.api.show': '/admin-api/disciplines/[discipline_id]',
  'admin.disciplines.api.details': '/admin-api/disciplines/[discipline_id]/details',
  'admin.disciplines.api.balances': '/admin-api/disciplines/[discipline_id]/balances',
  'admin.tutor-tasks.data': '/admin-api/tutor-tasks',
  'admin.tutor-tasks.store': '/admin-api/tutor-tasks',
  'admin.tutor-tasks.export': '/admin-api/tutor-tasks/export',
  'admin.tutor-task.data': '/admin-api/tutor-tasks/[task_id]',
  'admin.tutor-task.update': '/admin-api/tutor-tasks/[task_id]',
  'admin.tutor-task.delete': '/admin-api/tutor-tasks/[task_id]',
  'admin.tutor-task.postpone-dates': '/admin-api/tutor-tasks/[task_id]/postpone-dates',
  'admin.tutor-task.postpone': '/admin-api/tutor-tasks/[task_id]/postpone',
  'admin.disciplines.api.files': '/admin-api/disciplines/[discipline_id]/files',
  'admin.disciplines.api.file': '/admin-api/disciplines/[discipline_id]/files/[file_id]',
  'admin.disciplines.api.file-packs': '/admin-api/disciplines/[discipline_id]/files/packs',
  'admin.disciplines.api.file-pack': '/admin-api/disciplines/[discipline_id]/files/packs/[pack_id]',
  'admin.disciplines.api.file-pack.send': '/admin-api/disciplines/[discipline_id]/files/packs/[pack_id]/send',
  'admin.disciplines.api.certificate': '/admin-api/disciplines/[discipline_id]/certificate',
  'admin.disciplines.api.stage-logs': '/admin-api/disciplines/[discipline_id]/stage-logs',
  'admin.disciplines.api.stage-comments': '/admin-api/disciplines/[discipline_id]/stage-comments',
  'admin.disciplines.api.stage-comment': '/admin-api/disciplines/[discipline_id]/stage-comments/[comment_id]',
  'admin.disciplines.api.changelog': '/admin-api/disciplines/[discipline_id]/changelog',
  'admin.disciplines.api.activation': '/admin-api/disciplines/[discipline_id]/activation',
  'admin.disciplines.api.progress-reports': '/admin-api/disciplines/[discipline_id]/progress-reports',
  'admin.disciplines.api.progress-report': '/admin-api/disciplines/[discipline_id]/progress-reports/[report_id]',
  'admin.disciplines.api.orders': '/admin-api/disciplines/[discipline_id]/orders',
  'admin.disciplines.api.orders.calculate': '/admin-api/disciplines/[discipline_id]/orders/calculate',
  'admin.disciplines.api.subscriptions': '/admin-api/disciplines/[discipline_id]/subscriptions',
  'admin.disciplines.api.subscriptions.calculate': '/admin-api/disciplines/[discipline_id]/subscriptions/calculate',
  'admin.disciplines.api.enroll.send': '/admin-api/disciplines/[discipline_id]/enroll/send',
  'admin.disciplines.api.schedule.tutor-availability': '/admin-api/disciplines/[discipline_id]/schedule/tutor-availability',
  'admin.disciplines.api.schedule.update': '/admin-api/disciplines/[discipline_id]/schedule',
  'admin.disciplines.api.schedule.allocate': '/admin-api/disciplines/[discipline_id]/schedule/allocate',
  'admin.disciplines.api.schedule.allocation-results': '/admin-api/disciplines/[discipline_id]/schedule/allocation-results/[activation_run_id]',
  'admin.disciplines.api.schedule.store': '/admin-api/disciplines/[discipline_id]/schedule/[activation_run_id]',
  'admin.disciplines.api.schedule.change-tutor': '/admin-api/disciplines/[discipline_id]/schedule/change-tutor',
  'admin.disciplines.api.schedule.setup-lessons': '/admin-api/disciplines/[discipline_id]/schedule/setup-lessons',
  'admin.products': '/admin-api/products',
  'admin.disciplines.api.update': '/admin-api/disciplines/[discipline_id]',
  'admin.disciplines.api.destroy': '/admin-api/disciplines/[discipline_id]',
  'admin.disciplines.api.duplicate': '/admin-api/disciplines/[discipline_id]/duplicate',
  'admin.disciplines.api.merge-profiles': '/admin-api/disciplines/[discipline_id]/merge-profiles',
  'admin.disciplines.api.customer-details': '/admin-api/customers/[customer_id]/details',
  'admin.disciplines.orders.create': '/admin/disciplines/[discipline_id]/orders/create',
  'admin.kanban.upgrade': '/admin/kanban/upgrade',
  'admin.kanban.billing': '/admin/kanban/billing',
  'admin.disciplines.show': '/admin/disciplines/[discipline_id]',
  'admin.discipline.balances': '/admin/disciplines/[discipline_id]/balances',
  'admin.discipline.tasks': '/admin/disciplines/[discipline_id]/tasks',
  'admin.discipline.files': '/admin/disciplines/[discipline_id]/files',
  'admin.discipline.report': '/admin/disciplines/[discipline_id]/report',
  'admin.discipline.stage-logs': '/admin/disciplines/[discipline_id]/stage-logs',
  'admin.discipline.comments': '/admin/disciplines/[discipline_id]/comments',
  'admin.discipline.changelog': '/admin/disciplines/[discipline_id]/changelog',
  'admin.discipline.surveys': '/admin/disciplines/[discipline_id]/surveys',
  'admin.discipline.activation': '/admin/disciplines/[discipline_id]/activation',
  'admin.discipline.progress-reports': '/admin/disciplines/[discipline_id]/progress-reports',
  'admin.customers.index': '/admin/customers',
  'admin.customers.show': '/admin-api/customers/[customer_id]',
  'admin.customers.data': '/admin-api/customers',
  'admin.customer.destroy': '/admin-api/customers/[customer_id]',
  'admin.customer.behalf': '/admin-api/customers/[customer_id]/behalf',
  'admin.customer.details-data': '/admin-api/customers/[customer_id]/details',
  'admin.customer.comments-data': '/admin-api/customers/[customer_id]/comments',
  'admin.customer.changelog-data': '/admin-api/customers/[customer_id]/changelog',
  'admin.customer.referral-program': '/admin-api/customers/[customer_id]/referral-program',
  'admin.customer.referrals': '/admin-api/customers/[customer_id]/referral-program/referrals',
  'admin.customer.credits-history': '/admin-api/customers/[customer_id]/referral-program/credits-history',
  'admin.customer.credits-add': '/admin-api/customers/[customer_id]/referral-program/credits/add',
  'admin.customer.credits-remove': '/admin-api/customers/[customer_id]/referral-program/credits/remove',
  'admin.customer.update': '/admin-api/customers/[customer_id]',
  'admin.customer.crm-pull': '/admin-api/customers/[customer_id]/crm-pull',
  'admin.customer.crm-push': '/admin-api/customers/[customer_id]/crm-push',
  'admin.customer.send-reload': '/admin-api/customers/[customer_id]/send-reload',
  'admin.customer.respond-push': '/admin-api/customers/[customer_id]/respond-push',
  'admin.customer.kid-store': '/admin-api/kids',
  'admin.kanban.service': '/admin/kanban/service',
  'admin.attendance-setter.index': '/admin/attendance-setter',
  'admin.demo-sale.lessons.index': '/admin/demo-sale/lessons',
  'admin.demo-slots-management.data': '/admin-api/demo-slots-management',
  'admin.demo-slots-management.update': '/admin-api/demo-slots-management',
  'admin.sales-queue-slots-management.data': '/admin-api/sales-queue-slots-management',
  'admin.sales-queue-slots-management.update': '/admin-api/sales-queue-slots-management',
  'admin.paid-lessons.index': '/admin/paid-lessons',
  'admin.demo-lessons.index': '/admin/demo-lessons',
  'admin.orders.show': '/admin/orders/[order_id]',
  'admin.orders.data': '/admin-api/orders',
  'admin.order.details': '/admin-api/orders/[order_id]',
  'admin.order.sync': '/admin-api/orders/[order_id]/sync',
  'admin.order.retry': '/admin-api/orders/[order_id]/retry',
  'admin.order.send': '/admin-api/orders/[order_id]/send',
  'admin.order.invoices': '/admin-api/orders/[order_id]/invoices',
  'admin.order.invoices.preview': '/admin-api/orders/[order_id]/invoices/preview',
  'admin.order.invoice.download': '/admin-api/orders/[order_id]/invoices/[invoice_id]/download',
  'admin.subscriptions.data': '/admin-api/subscriptions',
  'admin.subscription.update': '/admin-api/subscriptions/[subscription_id]',
  'admin.subscription.sync': '/admin-api/subscriptions/[subscription_id]/sync',
  'admin.subscription.pause': '/admin-api/subscriptions/[subscription_id]/pause',
  'admin.subscription.change-pause': '/admin-api/subscriptions/[subscription_id]/pause',
  'admin.subscription.resume': '/admin-api/subscriptions/[subscription_id]/resume',
  'admin.subscription.cancel': '/admin-api/subscriptions/[subscription_id]/cancel',
  'admin.subscription.products': '/admin-api/subscriptions/[subscription_id]/products',
  'admin.subscription.change-product': '/admin-api/subscriptions/[subscription_id]/change-product',
  'admin.subscription.recalculate': '/admin-api/subscriptions/[subscription_id]/recalculate',
  'admin.subscription.discount': '/admin-api/subscriptions/[subscription_id]/discount',
  'admin.subscription.send-upsell': '/admin-api/subscriptions/[subscription_id]/send-upsell',
  'admin.subscription.split': '/admin-api/subscriptions/[subscription_id]/split',
  'admin.subscription.charge-now': '/admin-api/subscriptions/[subscription_id]/charge-now',
  'admin.subscription.changelog': '/admin-api/subscriptions/[subscription_id]/changelog',
  'admin.changelog.subscription': '/admin/subscriptions/[subscription_id]/changelog',
  'admin.surveys.data': '/admin-api/surveys',
  'admin.surveys.export': '/admin-api/surveys/export',
  'admin.promocodes.index': '/admin/promocodes',
  'admin.promocodes.data': '/admin-api/promocodes',
  'admin.promocodes.store': '/admin-api/promocodes',
  'admin.promocode.update': '/admin-api/promocodes/[promocode_id]',
  'admin.tutors.index': '/admin/tutors',
  'admin.tutor-payments.index': '/admin/tutor-payments',
  'admin.tutors.payment-policies.index': '/admin/tutor-payment-policies',
  'admin.tutor-schedule.day': '/admin/tutor-schedule/day',
  'admin.tutor-tasks.index': '/admin/tutor-tasks',
  'admin.tutor-attendance-rates.index': '/admin/tutor-attendance-rates',
  'admin.newsletters.index': '/admin/newsletters',
  'admin.newsletter-logs.index': '/admin/newsletter-logs',
  'admin.users.index': '/admin/users',
  'admin.teams.index': '/admin/teams',
  'admin.users.data': '/admin-api/users',
  'admin.user.data': '/admin-api/users/[user_id]',
  'admin.users.update': '/admin-api/users/[user_id]',
  'admin.users.delete': '/admin-api/users/[user_id]',
  'admin.teams.data': '/admin-api/teams',
  'admin.team.data': '/admin-api/teams/[team_id]',
  'admin.teams.create': '/admin-api/teams',
  'admin.teams.update': '/admin-api/teams/[team_id]',
  'admin.teams.delete': '/admin-api/teams/[team_id]',
  'admin.api-tokens': '/admin-api/api-tokens',
  'admin.api-tokens.update': '/admin-api/api-tokens/[token_id]',
  'admin.api-tokens.delete': '/admin-api/api-tokens/[token_id]',
  'admin.settings.data': '/admin-api/settings',
  'admin.oauth.data': '/admin-api/oauth',
  'admin.oauth.delete': '/admin-api/oauth/[id]',
  'admin.changelog.index': '/admin/changelog',
  'admin.changelog.list': '/admin-api/changelog',
  'admin.changelog.items': '/admin-api/changelog/[action_id]',
  'admin.helpers.push.1m': '/admin-api/helpers/push-1m',
  'admin.helpers.push.10m': '/admin-api/helpers/push-10m',
  'admin.helpers.promocodes.expire': '/admin-api/helpers/promocodes/expire',
  'admin.helpers.eve.sync': '/admin-api/helpers/eve/sync',
  'admin.helpers.kanban.dts-notification': '/admin-api/helpers/kanban/dts-notification',
  'admin.helpers.sqa.agent-assign': '/admin-api/helpers/kanban/agent-assign',
  'admin.helpers.sqa.sale-status-call-now': '/admin-api/helpers/kanban/sale-status-call-now',
  'admin.helpers.sqa.clear-agent-slots': '/admin-api/helpers/kanban/clear-agent-slots',
  'admin.helpers.notifications.tutor-no-show': '/admin-api/helpers/kanban/tutor-no-show',
  'admin.helpers.newsletters.send': '/admin-api/helpers/newsletters/send',
  'admin.helpers.newsletters.debug': '/admin-api/helpers/newsletters/debug',
  'admin.helpers.recordings.retrieve': '/admin-api/helpers/retrieve-recordings',
  'admin.helpers.stripe.pause-subscriptions': '/admin-api/helpers/pause-stripe-subscriptions',
  'admin.helpers.bookings.delete-upcoming-reserved-lessons': '/admin-api/helpers/delete-upcoming-reserved-lessons',
  'admin.helpers.activation.run-auto-activation': '/admin-api/helpers/activation/run-auto-activation',
  'admin.helpers.tutor.calculate-attendance-rate': '/admin-api/helpers/tutor/calculate-attendance-rate',
  'admin.helpers.tutor.calculate-conversion-rate': '/admin-api/helpers/tutor/calculate-conversion-rate',
  'admin.helpers.tutor.calculate-student-attendance-rate': '/admin-api/helpers/tutor/calculate-student-attendance-rate',
  'admin.helpers.tutor-slots.cancel-for-interval': '/admin-api/helpers/tutor-slots/cancel-for-interval',
  'admin.helpers.extra-rates.send-applied-notifications': '/admin-api/helpers/extra-rates/send-applied-notifications',
  'admin.helpers.extra-rates.send-remaining-slots-notifications': '/admin-api/helpers/extra-rates/send-remaining-slots-notifications',
  'admin.helpers.credits.apply-upcoming': '/admin-api/helpers/credits/apply-upcoming',
  'admin.sales-tax-rates.import': '/admin-api/sales-tax-rates/import',
  'admin.curriculum.import': '/admin-api/curriculum/import',
  'admin.tutor-payments.import': '/admin-api/tutor-payments/import',
  'admin.assessment-templates.index': '/admin-api/assessment-templates',
  'admin.assessment-templates.show': '/admin-api/assessment-templates/[template_id]',
  'admin.assessment-templates.store': '/admin-api/assessment-templates',
  'admin.assessment-templates.update': '/admin-api/assessment-templates/[template_id]',
  'admin.assessment-templates.destroy': '/admin-api/assessment-templates/[template_id]',
  'admin.assessment-templates.duplicate': '/admin-api/assessment-templates/[template_id]/duplicate',
  'admin.assessment-templates.media.store': '/admin-api/assessment-templates/[template_id]/media',
  'admin.assessment-templates.media.show': '/admin-api/assessment-templates/[template_id]/media',
  'admin.assessment-standards.index': '/admin-api/assessment-standards',
  'admin.assignment-templates.index': '/admin-api/assignment-templates',
  'admin.assignment-templates.show': '/admin-api/assignment-templates/[template_id]',
  'admin.assignment-templates.store': '/admin-api/assignment-templates',
  'admin.assignment-templates.update': '/admin-api/assignment-templates/[template_id]',
  'admin.assignment-templates.destroy': '/admin-api/assignment-templates/[template_id]',
  'admin.assignment-templates.duplicate': '/admin-api/assignment-templates/[template_id]/duplicate',
  'admin.assignment-templates.media.store': '/admin-api/assignment-templates/[template_id]/media',
  'admin.assignment-templates.media.show': '/admin-api/assignment-templates/[template_id]/media',
  'admin.learning-materials.index': '/admin-api/learning-materials',
  'admin.learning-materials.suggestions': '/admin-api/learning-materials/suggestions',
  'admin.learning-materials.show': '/admin-api/learning-materials/[material_id]',
  'admin.learning-materials.store': '/admin-api/learning-materials',
  'admin.learning-materials.update': '/admin-api/learning-materials/[material_id]',
  'admin.learning-materials.duplicate': '/admin-api/learning-materials/[material_id]/duplicate',
  'admin.curriculum.modules.index': '/admin-api/curriculum/modules',
  'admin.lessons.api.index': '/admin-api/disciplines/[discipline_id]/lessons',
  'admin.lessons.api.check-schedule': '/admin-api/disciplines/[discipline_id]/lessons/check-schedule',
  'admin.tutors.availability': '/admin-api/tutors/availability',
  'admin.tutor-schedule.week': '/admin/tutor-schedule/week',
  'admin.lessons.api.lesson': '/admin-api/disciplines/[discipline_id]/lessons/[lesson_id]',
  'admin.lessons.api.approve-join': '/admin-api/disciplines/[discipline_id]/lessons/[lesson_id]/approve-join',
  'admin.lessons.api.connection-quality': '/admin-api/disciplines/[discipline_id]/lessons/[lesson_id]/connection-quality',
  'admin.lessons.api.reschedule': '/admin-api/disciplines/[discipline_id]/lessons/[lesson_id]/reschedule',
  'admin.lessons.api.recurring': '/admin-api/disciplines/[discipline_id]/recurring-lessons',
  'admin.lessons.api.recurring-track': '/admin-api/disciplines/[discipline_id]/recurring-lessons/track',
  'admin.tutors.recurring-availability': '/admin-api/tutors/recurring-availability',
  'admin.booking.changelog': '/admin-api/bookings/[booking_id]/changelog',
  'admin.broadcasting.auth': '/broadcasting/auth',
}

export default routes
